import type { SVGProps } from 'react';

const SvgLoyalty = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="smart-send-time">
      <path d="m25.52 12.23-6.11-.89-2.74-5.53a.77.77 0 0 0-1.34 0l-2.74 5.53-6.11.89a.75.75 0 0 0-.41 1.28l4.42 4.31-1.05 6.09a.75.75 0 0 0 1.09.79L16 21.83l5.47 2.87a.72.72 0 0 0 .79-.06.76.76 0 0 0 .3-.73l-1-6.09 4.42-4.31a.75.75 0 0 0-.41-1.28ZM20.18 17a.76.76 0 0 0-.21.67l.85 5-4.47-2.35a.73.73 0 0 0-.7 0l-4.47 2.35.85-5a.76.76 0 0 0-.21-.67L8.2 13.5l5-.73a.72.72 0 0 0 .56-.41L16 7.83l2.24 4.53a.72.72 0 0 0 .56.41l5 .73Z" />
      <path d="M16 .08A15.92 15.92 0 1 0 31.92 16 15.94 15.94 0 0 0 16 .08m0 30.34A14.42 14.42 0 1 1 30.42 16 14.44 14.44 0 0 1 16 30.42" />
    </g>
  </svg>
);

export default SvgLoyalty;
